import { mailApiPost } from "@/lib/api/client";

export type MailCachePurgeResponse = {
  success: boolean;
  purged: boolean;
  scope: "user" | "account";
  accountId: number | null;
  usedBytes: number;
  maxBytes: number;
  usedPercent: number;
};

export function purgeMailCache(params: { accountId?: number; purgeAll?: boolean }) {
  return mailApiPost<MailCachePurgeResponse>("cache/purge.php", {
    accountId: params.accountId,
    purgeAll: params.purgeAll === true,
  });
}
